import { 
    Map,
    // List 
} from "immutable";
import { STATE_STATUS, MPA_DPA_ACTIONS } from "constants";
import { BusinessProgramDetailPipeline } from "utilities";
import { 
    BuyerQualificationDetailRecord,
    BusinessProgramInterestRecord,
    BusinessProgramFeeRecord,
    BusinessProgramFacilityDetailRecord,
    BusinessProgramRecourseDetailRecord,
    BusinessProgramCashbackRecord,
    BusinessProgramAttachments,
    BusinessBasicDetailRecord,
    AgreementDetailRecord
} from "records/schemes-record";


const INITIAL_STATE = new Map({
    business_program_list: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: null,
        count: 0
    }),
    business_program_detail: new Map({})
});


export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case MPA_DPA_ACTIONS.FETCH_BUSINESS_PROGRAM_LIST:
        return state.setIn(["business_program_list", "status"], STATE_STATUS.FETCHING);
    case MPA_DPA_ACTIONS.FETCHED_BUSINESS_PROGRAM_LIST:
        return state
            .setIn(["business_program_list", "status"], STATE_STATUS.FETCHED)
            .setIn(["business_program_list", "count"], payload.data.count)
            .setIn(["business_program_list", "data"], payload.data.results);
    case MPA_DPA_ACTIONS.FAILED_FETCH_BUSINESS_PROGRAM_LIST:
        return state
            .setIn(["business_program_list", "status"], STATE_STATUS.FETCH_FAILED);
    case MPA_DPA_ACTIONS.FETCH_BUSINESS_PROGRAM_DETAIL:
    case MPA_DPA_ACTIONS.FETCH_COMPANY_BUSINESS_PROGRAM_DETAIL:
        return state.setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.FETCHING);
    case MPA_DPA_ACTIONS.FETCHED_COMPANY_BUSINESS_PROGRAM_DETAIL:
    case MPA_DPA_ACTIONS.FETCHED_BUSINESS_PROGRAM_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.FETCHED)
            .setIn(["business_program_detail", payload.id, "data"], BusinessProgramDetailPipeline.run(payload.data));
    case MPA_DPA_ACTIONS.FAILED_FETCH_BUSINESS_PROGRAM_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.FETCH_FAILED);
    
    case MPA_DPA_ACTIONS.CREATE_BUSINESS_PROGRAM_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_PROGRAM_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data"], BusinessProgramDetailPipeline.run(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_PROGRAM_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_PROGRAM_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_PROGRAM_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data"], BusinessProgramDetailPipeline.run(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_PROGRAM_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);
    
    case MPA_DPA_ACTIONS.CREATE_BUSINESS_QUALIFICATION_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_QUALIFICATION_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_buyer_qualification_detail"],new BuyerQualificationDetailRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_QUALIFICATION_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_QUALIFICATION_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_QUALIFICATION_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_buyer_qualification_detail"], new BuyerQualificationDetailRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_QUALIFICATION_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);
    
    case MPA_DPA_ACTIONS.CREATE_BUSINESS_INTEREST_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_INTEREST_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_interest"], payload.data.map(_ => new BusinessProgramInterestRecord(_)));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_INTEREST_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_INTEREST_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_INTEREST_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_interest"], payload.data.map(_ => new BusinessProgramInterestRecord(_)));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_INTEREST_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);       
    
    case MPA_DPA_ACTIONS.CREATE_BUSINESS_FEE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_FEE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_fee"],payload.data.map(_ => new BusinessProgramFeeRecord(_)));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_FEE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_FEE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_FEE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_fee"], payload.data.map(_ => new BusinessProgramFeeRecord(_)));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_FEE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);

    case MPA_DPA_ACTIONS.CREATE_BUSINESS_FACILITY_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_FACILITY_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_facility_details"],payload.data.map(_ => new BusinessProgramFacilityDetailRecord(_)));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_FACILITY_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_FACILITY_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_FACILITY_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_facility_details"], payload.data.map(_ => new BusinessProgramFacilityDetailRecord(_)));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_FACILITY_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);
    case MPA_DPA_ACTIONS.CREATE_BUSINESS_RECOURSE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_RECOURSE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_recourse_detail"],new BusinessProgramRecourseDetailRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_RECOURSE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_RECOURSE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_RECOURSE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_recourse_detail"], new BusinessProgramRecourseDetailRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_RECOURSE_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);
    case MPA_DPA_ACTIONS.CREATE_BUSINESS_CASHBACK_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_CASHBACK_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_cashback"],new BusinessProgramCashbackRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_CASHBACK_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_CASHBACK_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_CASHBACK_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_cashback"], new BusinessProgramCashbackRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_CASHBACK_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);

    case MPA_DPA_ACTIONS.CREATE_BUSINESS_ATTACHMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_ATTACHMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_attachments"],new BusinessProgramAttachments(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_ATTACHMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_ATTACHMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_ATTACHMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_attachments"], new BusinessProgramAttachments(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_ATTACHMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);
    case MPA_DPA_ACTIONS.CREATE_BUSINESS_PROGRAM_BASIC_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_PROGRAM_BASIC_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_basic_details"],new BusinessBasicDetailRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_PROGRAM_BASIC_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_PROGRAM_BASIC_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_PROGRAM_BASIC_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_basic_details"], new BusinessBasicDetailRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_PROGRAM_BASIC_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);
    case MPA_DPA_ACTIONS.CREATE_BUSINESS_AGREEMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATING);
    case MPA_DPA_ACTIONS.CREATED_BUSINESS_AGREEMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_agreement_details"],new AgreementDetailRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_CREATE_BUSINESS_AGREEMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.CREATE_FAILED);

    case MPA_DPA_ACTIONS.UPDATE_BUSINESS_AGREEMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATING);
    case MPA_DPA_ACTIONS.UPDATED_BUSINESS_AGREEMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATED)
            .setIn(["business_program_detail", payload.id, "data", "business_program_agreement_details"], new AgreementDetailRecord(payload.data));
        
    case MPA_DPA_ACTIONS.FAILED_UPDATE_BUSINESS_AGREEMENT_DETAIL:
        return state
            .setIn(["business_program_detail", payload.id, "status"], STATE_STATUS.UPDATE_FAILED);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
